import React, { useEffect, useState } from "react";
import UltimoTorneoTipo from "./UltimoTorneoTipo.js";
import CuadroDatos from "../UI/CuadroDatos.js";
import ListaLinksScroleable from "../UI/ListaLinksScroleable.js";
import { Categoria } from "../constantes/Parametros.js";
import * as TipoTorneo from "../constantes/TipoTorneo.js";
import { OrdenarListaFechaDesc } from "../funciones/FuncionesTorneos.js";
import useGetListaURL from "../../hooks/useGetListaURL.js";
import styles from "./CuadroTipoTorneo.module.css";

const CuadroTipoTorneo = (props) => {
  const tipoTorneo = props.tipoTorneo;
  const [listaTorneos, setListaTorneos] = useState([]);
  const [ultimoTorneo, setUltimoTorneo] = useState(null);
  const { isCargando, erroresGetLista, fetchData, resetErroresGetLista } = useGetListaURL();

  useEffect(() => {
    resetErroresGetLista();
  }, [resetErroresGetLista]);

  useEffect(() => {
    const ordenarTorneos = (lista) => {
      const listaFiltrada = lista.filter(item => item.fechaFin !== null);
      if (listaFiltrada) {
        const listaDesc = OrdenarListaFechaDesc(listaFiltrada);
        setUltimoTorneo(listaDesc[0]);
        setListaTorneos(listaDesc.slice(1));
      } else {
        setUltimoTorneo(null);
        setListaTorneos([]);
      }
    }

    if (tipoTorneo) {
      if (tipoTorneo.codigo === TipoTorneo.JUEGOS_OLIMPICOS) {
        fetchData("torneos?tipoTorneo="+tipoTorneo.codigo, ordenarTorneos);
      } else {
        fetchData("torneos?categoria="+Categoria.MAYOR.codigo+"&tipoTorneo="+tipoTorneo.codigo, ordenarTorneos);
      }
    } else {
      setUltimoTorneo(null);
      setListaTorneos([]);
    }
  }, [tipoTorneo, fetchData]);

  return (
    <div className={`${styles.cuadro}`}>
      <CuadroDatos
        titulo={tipoTorneo.descripcion}
        mostrar={true}
        isCargando={isCargando}
        error={erroresGetLista}
      >
        <UltimoTorneoTipo torneo={ultimoTorneo} />
        <div className={`${styles.listaTorneos}`}>
          <span>Ediciones anteriores</span>
          <ListaLinksScroleable
            path="/torneos/"
            lista={listaTorneos}
            cantVisibles={5}
            altoFijo={true}
          />
        </div>
      </CuadroDatos>
    </div>
  );
};

export default CuadroTipoTorneo;